import { render, staticRenderFns } from "./DialogCancel.vue?vue&type=template&id=1032b0fd&scoped=true&"
import script from "./DialogCancel.vue?vue&type=script&lang=js&"
export * from "./DialogCancel.vue?vue&type=script&lang=js&"
import style0 from "./DialogCancel.vue?vue&type=style&index=0&id=1032b0fd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1032b0fd",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!D:/ctg-code/qihuibao-web/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib'
import { VCardText } from 'vuetify/lib'
import { VDialog } from 'vuetify/lib'
import { VDivider } from 'vuetify/lib'
installComponents(component, {VCard,VCardText,VDialog,VDivider})
